import React, { useEffect } from 'react';
import { css } from '@emotion/core';
import { useDispatch, useSelector } from 'react-redux';
import { PrimaryButton, Heading } from '@weave/design-system';
import { sendPasswordReset } from '../../redux/actions/users';
import { getUser } from '../../redux/actions/auth/user/user.action';
import { ChangePasswordForm } from './change-password-form.component';

export const UserConfig = () => {
  const username = useSelector((state: any) => state.auth.user.username);
  const user = useSelector((state: any) => state.user);
  const { UserID: userId } = user;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUser({ username }));
  }, [username]);

  const sendPasswordResetEmail = () => {
    dispatch(
      sendPasswordReset({
        Username: username,
        UserID: userId,
        FirstName: user.FirstName,
        LastName: user.LastName,
      })
    );
  };

  return (
    <div className="user-config">
      <div
        className="container-fluid"
        css={css`
          @media only screen and (max-width: 790px) {
            padding: 0;
          }
        `}
      >
        <div
          css={css`
            padding: 20px;
            text-align: center;
          `}
        >
          <Heading
            css={css`
              text-align: center;
              margin-bottom: 0;
            `}
          >
            Weave User Configurations
          </Heading>
        </div>
        <div
          className="main"
          css={css`
            align-items: center;
            display: flex;
            flex-direction: column;
          `}
        >
          <section>
            <Heading level={3} as="h3">
              Change Password
            </Heading>

            <div>
              <div
                css={css`
                  margin-top: 20px;
                  margin-bottom: 20px;
                `}
              >
                <span
                  css={css`
                    font-weight: bold;
                  `}
                >
                  Username:{' '}
                </span>
                {username}
              </div>
              <div
                css={css`
                  font-weight: bold;
                  margin-bottom: 10px;
                `}
              >
                Change Password:{' '}
                <div>
                  <ChangePasswordForm user={user} />
                </div>
              </div>
              <PrimaryButton onClick={sendPasswordResetEmail}>
                Send Reset Email
              </PrimaryButton>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
